<template>
  <v-dialog v-model="show" max-width="500px" :fullscreen="isMobile">
    <div class="position-block-dialog p-relative">
      <v-card tile class="overflow-y-auto full-height d-flex flex-column">
        <div
          style="height: auto;"
          class="d-flex py-5 px-2 full-width overflow-hidden"
        >
          <div class="toolbar-titles-container d-flex flex-column">
            <v-toolbar-title class="pl-5 text-overflow-ellipsis">{{ title }}</v-toolbar-title>
            <v-toolbar-title class="pl-5 toolbar-subheader">{{ subtitle }}</v-toolbar-title>
          </div>
          <v-spacer></v-spacer>
          <simple-tooltip tooltip="Redigera platsavstängning">
            <v-btn
              @click="startEdit"
              icon
              class="mr-2"
            >
              <v-icon>mdi-pen</v-icon>
            </v-btn>
          </simple-tooltip>
          <v-btn icon v-if="isMobile" @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <div class="d-flex flex-column full-height">
          <v-list subheader class="flex-grow-1 px-4 pt-4">
            <v-list-item class="mb-4" style="min-height: 62px;">
              <v-list-item-icon class="my-auto">
                <v-icon>mdi-map-marker-off</v-icon>
              </v-list-item-icon>
              <div class="d-flex flex-row" style="flex: unset;">
                <div class="d-flex flex-column text-left">
                  <v-list-item-title class="text-left full-width">
                    <span>{{ closingDateFormatted }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle class="">Stängd från och med</v-list-item-subtitle>
                </div>
                <div class="d-flex ml-4">
                  <template v-if="positionBlock?.status === 'ongoing'">
                    <v-chip
                      small
                      color="success"
                      text-color="white"
                      class="my-auto"
                    >
                      Pågående
                    </v-chip>
                  </template>
                  <template v-else-if="positionBlock?.status === 'passed'">
                    <v-chip
                      small
                      color="primary"
                      text-color="white"
                      class="my-auto"
                    >
                      Passerad
                    </v-chip>
                  </template>
                  <template v-else-if="positionBlock?.status === 'future'">
                    <v-chip
                      small
                      color="info"
                      text-color="white"
                      class="my-auto"
                    >
                      Planerad
                    </v-chip>
                  </template>
                </div>
              </div>
            </v-list-item>

            <v-list-item class="mb-4" style="min-height: 62px;">
              <v-list-item-icon class="my-auto">
                <v-icon>mdi-map-marker-check</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ openingDateFormatted }}
                </v-list-item-title>
                <v-list-item-subtitle>Platsen öppnar igen</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item style="min-height: 62px;">
              <v-list-item-icon class="my-auto">
                <v-icon>mdi-text-box-edit</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="white-space: break-spaces;">"{{ positionBlock?.reason ?? ' ' }}"</v-list-item-title>
                <v-list-item-subtitle>Anteckning</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-card-actions class="pa-3">
            <v-btn
              text
              color="error"
              @click="deletePositionBlock"
              :loading="dialog.isDeleting"
            >
              Ta bort platsavstängning
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

import SimpleTooltip from '@/components/common/SimpleTooltip.vue'

export default {
  name: 'PositionBlockDialog',
  components: {
    SimpleTooltip
  },
  data: () => ({}),
  computed: {
    ...mapState(
      {
        dialog: state => state.position.positionBlockDialog
      }
    ),
    show: {
      get () {
        return this.dialog.show
      },
      set (value) {
        this.$store.commit('position/SET_POSITION_BLOCK_DIALOG_SHOW', value)
      }
    },
    positionBlock: function () {
      return this.dialog.positionBlock
    },
    isMobile: function () {
      return this.$vuetify.breakpoint.mdAndDown
    },
    title: function () {
      if (!this.positionBlock) {
        return ''
      }
      return `Platsavstängning ${this.positionBlock.position.full_name}`
    },
    subtitle: function () {
      if (!this.positionBlock) {
        return ''
      }
      const nightsFormatted = window.conversion.diffInDays(this.positionBlock.closing_date, this.positionBlock.opening_date)
      return `Avstängd i ${nightsFormatted}`
    },
    closingDateFormatted: function () {
      if (!this.positionBlock) {
        return ''
      }
      return this.positionBlock.closing_date.toHumanReadableDate()
    },
    openingDateFormatted: function () {
      if (!this.positionBlock) {
        return ''
      }
      return this.positionBlock.opening_date.toHumanReadableDate()
    }
  },
  methods: {
    close: function () {
      this.show = false
    },
    startEdit: function () {
      this.$store.dispatch('position/startEditPositionBlock', { positionBlock: this.positionBlock })
      this.close()
    },
    deletePositionBlock: function () {
      this.$store.dispatch('position/deletePositionBlock', { positionBlock: this.positionBlock })
        .finally(() => {
          this.close()
        })
    }
  }
}
</script>
